import React from 'react';

interface VersionInfoProps {
  className?: string;
}

const VersionInfo: React.FC<VersionInfoProps> = ({ className = '' }) => {
  return (
    <div className={`text-center text-xs text-ink-subtle ${className}`}>
      <span>xLists 3.0.1</span>
      <span className="mx-2">·</span>
      <span>Vladimir Demidov</span>
      <span className="mx-2">·</span>
      <span>© 2026</span>
    </div>
  );
};

export default VersionInfo;
